import React, { useState } from 'react';
import ReactSlideDown from 'react-slidedown';
import 'react-slidedown/lib/slidedown.css';
import ChevronIcon from '../../../assets/ChevronIcon';
import {
  AccordionWrapper,
  HeaderWrapper,
  IconWrapper,
  Title,
} from './Accordion.styles';

type AccordionType = {
  headerTitle: string;
  icon: null | React.ReactNode;
  children: React.ReactNode;
  toggleStatusHandler: Function;
  dataQa: null | string;
  className?: string;
};

const Accordion = ({
  headerTitle,
  icon,
  toggleStatusHandler,
  children,
  dataQa,
  className = '',
}: AccordionType) => {
  const [toggle, setToggle] = useState(false);

  const handleToggle = () => {
    const toggleValue = !toggle;
    setToggle(toggleValue);
    toggleStatusHandler(toggleValue);
  };

  return (
    <AccordionWrapper className={className}>
      <HeaderWrapper onClick={handleToggle}>
        <Title data-qa={dataQa ? `${dataQa}-accordion-text` : `accordion-text`}>
          {headerTitle}
        </Title>
        <IconWrapper isOpen={toggle}>{icon || <ChevronIcon />}</IconWrapper>
      </HeaderWrapper>
      <ReactSlideDown>{toggle ? children : null}</ReactSlideDown>
    </AccordionWrapper>
  );
};
export default Accordion;
